import MistakesLeft from './MistakesLeft.vue';
export default MistakesLeft;
